import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SubscriptionService } from '../../../services/subscription.service';
import { PaymentMethodsStaticDataService } from '../../../services/payment-methods-static-data.service';
import { AtabexDataService } from '../../../services/atabex-data.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';
import { onPhoneNumberEntered } from '../../../shared/helper-functions';
import { openModal, closeModal } from '../../../shared/modal-functions';
import { whitespaceValidator } from '../../../shared/whitespace-validator';
import { subscriptionViewSpanish } from '../subscription.static.data';

@Component({
  selector: 'app-add-new-bank-account',
  templateUrl: './add-new-bank-account.component.html',
  styleUrls: ['../../../app.component.css']
})
export class AddNewBankAccountComponent implements OnInit {
  // Static Data
  subscriptionView: any;
  // Control view  
  openModal: any;
  closeModal: any;
  onPhoneNumberEntered: any;
  savePaymentMethodCompleted: boolean;
  // Fields validation
  showRequiredBillingAddress: boolean;
  invalidRoutingNumber: boolean;
  // User data
  newBankAccountForm: FormGroup;
  selectedBillingAddressForBankAccount: object;

  constructor(public formBuilder: FormBuilder, public subscriptionService: SubscriptionService, public paymentMethodsStaticDataService: PaymentMethodsStaticDataService, public atabexDataService: AtabexDataService, public googleAnalyticsService: GoogleAnalyticsService) {
    this.subscriptionView = subscriptionViewSpanish;
    this.openModal = openModal;
    this.closeModal = closeModal;
    this.onPhoneNumberEntered = onPhoneNumberEntered;
  }

  ngOnInit() {
    this.savePaymentMethodCompleted = true;
    this.newBankAccountForm = this.formBuilder.group({
      name: ['', [Validators.required, whitespaceValidator]],
      accountNumber: ['', [Validators.required]],
      abaRouting: ['', [Validators.required]],
    });
  }

  /*
   * Validate a billing address is selected
   * Creates new bank account if all the required fields are not empty and a billing address is selected
  */
  addBankAccountPaymentMethodWithExistingAddress() {
    !this.selectedBillingAddressForBankAccount ? this.showRequiredBillingAddress = true : this.showRequiredBillingAddress = false;
    if (this.selectedBillingAddressForBankAccount) {
      const customerAddressId = this.selectedBillingAddressForBankAccount['CustAddrID'];
      this.addNewBankAccount(customerAddressId);
    }
  }

  /*
   * Creates new bank account payment method
  */
  addNewBankAccount(customerAddressId) {
    this.savePaymentMethodCompleted = false;
    const payload = {
      PaymentMethodID: null,
      CustID: this.subscriptionService.customerId,
      PaymentTypeID: this.subscriptionService.atabexIdentifiers['bankAccountId'],
      AccountNumber: this.accountNumber.value,
      CreditCardType: '',
      CCExpirationMonth: '',
      CCExpirationYear: '',
      CreditCardName: this.name.value,
      CreditCardCVC: '',
      AbaRouting: this.abaRouting.value,
      Visible: true,
      CollectionTypeID: this.subscriptionService.selectedSubscription['CollectionTypeID'],
      CustAddrID: customerAddressId
    }
    this.subscriptionService.createOrUpdatePaymentMethod(payload).subscribe(
      (response) => {
        this.savePaymentMethodCompleted = true;
        this.subscriptionService.toggleAddBankAccountForm = false;
      },
      (error) => {
        this.savePaymentMethodCompleted = true;
        if (error.status === 702) { // invalid routing number
          this.invalidRoutingNumber = true;
        } else { // error with stored procedure
          this.openModal('#errorModal');
        }
      });
  }

  selectBillingAddress(address) {
    this.selectedBillingAddressForBankAccount = address;
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }

  get name() { return this.newBankAccountForm.get('name'); }
  get accountNumber() { return this.newBankAccountForm.get('accountNumber'); }
  get abaRouting() { return this.newBankAccountForm.get('abaRouting'); }

}

interface BankAccountPaymentMethod {
  name: string,
  accountNumber: string,
  abaRouting: string
}





// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/add-new-bank-account/add-new-bank-account.component.ts